module.exports = __webpack_public_path__ + "img/10no-six.0a5b26c9.jpg";